import { useRef, useState, useEffect } from 'react';
import dayjs from 'dayjs';
import { useDataTable } from '../../../../modules/table/DataTable';
import { Dropdown } from 'bootstrap';

interface Props {
  defaultPeriod?: '1h' | '7d' | '30d';
}

const UserSessionTimeFilterDropdown: React.FC<Props> = ({ defaultPeriod = '1h' }) => {
  const { filter, updateFilter, clearFilter } = useDataTable();

  const [label, setLabel] = useState('Operação');
  const toggleRef = useRef<HTMLButtonElement>(null);

  const handleFilter = (period?: string) => {
    if (period === '1h') {
      setLabel('1 hora atrás');
      updateFilter({
        ...filter,
        after: dayjs().subtract(1, 'hour').toISOString(),
      });
    } else if (period === '7d') {
      setLabel('7 dias atrás');
      updateFilter({
        ...filter,
        after: dayjs().subtract(7, 'day').toISOString(),
      });
    } else if (period === '30d') {
      setLabel('30 dias atrás');
      updateFilter({
        ...filter,
        after: dayjs().subtract(30, 'day').toISOString(),
      });
    } else {
      setLabel('Operação');
      clearFilter('after');
    }

    // fecha dropdown
    if (toggleRef.current) {
      Dropdown.getOrCreateInstance(toggleRef.current).hide();
    }
  };

  useEffect(() => {
    if (!filter?.after) {
      handleFilter(defaultPeriod);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!filter?.after) return;

    const diffHours = filter.after ? dayjs().diff(dayjs(filter.after as string), 'hour') : 0;
    const diffDays = dayjs().diff(dayjs(filter.after as string), 'day');

    if (diffHours < 2) {
      setLabel('1 hora atrás');
    } else if (diffDays < 8) {
      setLabel('7 dias atrás');
    } else if (diffDays < 31) {
      setLabel('30 dias atrás');
    } else {
      setLabel('Operação');
    }
  }, [filter?.after]);

  return (
    <div className="dropdown">
      <button
        ref={toggleRef}
        className={`btn btn-sm btn-light dropdown-toggle ${label === 'Operação' ? 'text-gray-500' : 'text-primary'}`}
        data-bs-toggle="dropdown"
        type="button"
      >
        {label}
      </button>
      <div className="dropdown-menu">
        <div className="m-2">
          <h6 className="dropdown-header fw-bold text-gray-800">Período</h6>
          <div className="dropdown-divider mx-2" />
          <button className="dropdown-item text-gray-700 rounded" type="button" onClick={() => handleFilter('1h')}>
            1 hora atrás
          </button>
          <button className="dropdown-item text-gray-700 rounded" type="button" onClick={() => handleFilter('7d')}>
            7 dias atrás
          </button>
          <button className="dropdown-item text-gray-700 rounded" type="button" onClick={() => handleFilter('30d')}>
            30 dias atrás
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserSessionTimeFilterDropdown;
